<template>
    <transition name="modal-fade">
        <div class="bsModal-backdrop">
            <div class="bsModal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
                <header class="bsModal-header" id="modalTitle">                
                    <slot name="header">
                        This is a default title!                        
                    </slot>
                    <button type="button" class="btn-close" @click="close" aria-label="Close modal">X</button>
                </header>
                <section class="bsModal-body" id="modalDescription">
                    <slot name="body">
                        <p>I'm the default body!</p>
                    </slot>
                </section>
                <footer class="bsModal-footer" v-if="showFooter">
                    <slot name="footer">
                        <p>Im the default footer!</p>                        
                    </slot>
                </footer>            
            </div>
        </div>
    </transition>    
</template>

<script>
export default {
    name: 'bsModal',
    props: {
        showFooter: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        close() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss">
  .bsModal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1500;
  }

  .bsModal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-y: auto;
    max-height: calc(100vh - 110px);
    display: flex;
    flex-direction: column;    
    // min-width: 920px;
  }

  .bsModal-header,
  .bsModal-footer {
      display: flex;
      align-items: center;
      padding: 15px;
      display: flex;
  }

  .bsModal-header {
    border-bottom: 1px solid #eeeeee;
    // color: #4AAE9B;
    justify-content: space-between;
  }

  .bsModal-footer {
    border-top: 1px solid #eeeeee;
    // justify-content: flex-end;
  }

  .bsModal-body {
    position: relative;
  }

  .btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    // color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }
</style>


